module.exports = __webpack_public_path__ + "img/track-results.be18d2a2.svg";